import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';

export default class Contingent extends React.Component {
    renderSeat(seat) {
        let rateBooked = null;
        if (seat.booking) {
            rateBooked = this.renderBookedRate(seat.booking.rate_name);
        }

        return (
            <li key={seat.uuid} className="seat">
                <div className="seat-icon" />
                <div className="name">
                    <Trans
                        i18nKey="seat_info"
                        values={{
                            access: seat.access,
                            row: seat.row,
                            seat: seat.seat
                        }}
                    >
                        Access %access% Row %row% Seat %seat%
                    </Trans>
                    {rateBooked}
                </div>
            </li>
        );
    }

    renderBookedRate(name) {
        return (
            <div className="rate-booked">
                <Trans i18nKey="bookedRate">Rate booked:</Trans>
                {` ${name}`}
            </div>
        );
    }

    renderSeats() {
        if (!this.props.seats) {
            return null;
        }

        return (
            <ul key="seats" className="seats">
                {this.props.seats.map(seat => this.renderSeat(seat))}
            </ul>
        );
    }

    render() {
        let { activeBooking, inList, contingent, bookingState, seats = [] } = this.props;

        if (inList) {
            let seatsState = '';
            let total = seats.reduce((acc, currentValue) => {
                if (currentValue.booking_state === 'BOOKING_IN_PROGRESS') {
                    return acc + 1;
                }
                return acc;
            }, 0);
            if (total > 0) {
                seatsState = (
                    <Trans values={{ count: total }} i18nKey="booking_in_progress_seats">
                        %count% seat is being booked
                    </Trans>
                );
            }
            return (
                <li key={contingent.uuid} className="contingent" data-id={contingent.uuid}>
                    <div key="info" className="info">
                        <div className="name">
                            <div
                                className="contingent-icon"
                                style={{
                                    backgroundColor: contingent.color
                                }}
                            />
                            {contingent.name}
                        </div>
                        <div>{seatsState}</div>
                    </div>
                    {this.renderSeats()}
                </li>
            );
        }

        let seatState = null;
        if (bookingState === 'BOOKING_IN_PROGRESS') {
            seatState = (
                <div>
                    <Trans i18nKey="booking_in_progress">Booking in progress</Trans>
                </div>
            );
        }

        let bookingRate = null;
        if (activeBooking) {
            bookingRate = this.renderBookedRate(activeBooking.rate_name);
        }

        return (
            <div key={contingent.uuid} className="contingent" data-id={contingent.uuid}>
                <div key="info" className="info">
                    <div className="name">
                        <div
                            className="contingent-icon"
                            style={{
                                backgroundColor: contingent.color
                            }}
                        />
                        {contingent.name}
                    </div>
                    {seatState}
                    {bookingRate}
                </div>
                {this.renderSeats()}
            </div>
        );
    }
}

Contingent.defaultProps = {
    activeBooking: null
};

Contingent.propTypes = {
    activeBooking: PropTypes.object,
    bookingState: PropTypes.string,
    contingent: PropTypes.object.isRequired,
    inList: PropTypes.bool,
    seats: PropTypes.array
};
